// src/constants/urls.js

// API Constants
export const API = {
  BASE: process.env.VUE_APP_API_URL,
  AVATURN: process.env.VUE_APP_AVATURN_URL,
  TOKEN: process.env.VUE_APP_API_TOKEN,
  ENDPOINTS: {
    PHOTOS: '/posts/photo',
    AVATAR_NEW: '/avatars/new'
  }
};

// Asset Constants
export const ASSETS = {
  MODELS: {
    MALE: '/models/male.glb',
    FEMALE: '/models/female.glb',
    IDLE: '/idle.glb',
    LOGO: '/M.glb'
  },
  IMAGES: {
    LOGO: '/logo-horizontal.png',
    ARROW_NEXT: '/arrow-next.png',
    ARROW_PREV: '/arrow-prev.png',
    ARROW_DOWN: '/arrow_down.png',
    BACK: '/back__.png',
    BODY_ICON: '/body_icon.png',
    CHECK: '/check.png',
    BRUSH: '/brush.png',
    CUT: '/cut.png',
    CLOSE: '/close.png',
    REFRESH_WHITE: '/refresh_white.png',
    FORM: {
      STEP1: '/form/step1.png',
      STEP2: '/form/step2.png',
      STEP3: '/form/step3.png',
      STEP4: '/form/step4.png',
      STEP5: '/form/step5.png',
      FACE_FRONT: '/form/face-front.png',
      FACE_LEFT: '/form/face-left.png',
      FACE_RIGHT: '/form/face-right.png',
      MALE: '/form/male.png',
      FEMALE: '/form/female.png',
      INFO: '/form/info.png',
      SWITCH_CAM: '/form/switch-cam.png',
      BORDER: '/form/border.png',
      LOADING: '/form/loading.png',
      FACE: '/form/face.png'
    }
  }
};

// Helper functions
export const getPhotoUrl = (imageUrl) => {
  if (!imageUrl) return '';
  
  if (imageUrl.includes(`${API.BASE}${API.ENDPOINTS.PHOTOS}/`)) {
    return imageUrl;
  }
  return `${API.BASE}${API.ENDPOINTS.PHOTOS}/${imageUrl}`;
};